import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { getFontFamily } from "../../../utils/styleUtils";

// NOTE : This file is for Quoting Footer FAQs section styles
export const StyledBox = styled(Box)(({ theme }) => ({
    // Targeting the AccordionSummary using a custom class name
    '.accordionSummary': {
        display: 'inline-block',
        width: '100%',
        verticalAlign: 'top',
        background: 'none',
        border: 0,
        padding: 0,
        borderBottom: '1.5px solid #00000040 !important', // Using !important to override existing styles
    },

    '.accordionSummary:last-child': {
        border: '0 !important',
    },

    '.accordionSummary .accordionSummary-heading': {
        padding: 0,
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '18px',
        background: 'none',
    },

    '.accordionSummary > .accordionSummary-heading .MuiAccordionSummary-content': {
        margin : '14px 0',
        color : '#11728D',
        fontFamily : getFontFamily('body.fontFamily.secondary', theme),
        fontSize : '16px',
        fontWeight: '600',
        lineHeight: '28px',
        textTransform: 'none',
        textDecoration: 'none',
        textUnderlinePosition: 'from-font',
},
    '.accordionSummary > .accordionSummary-heading .MuiAccordionSummary-expandIconWrapper' : {
        color : '#11728D',
    },

    '.accordionSummary .accordionSummary-details': {
        padding: 0,
        paddingBottom: '14px',
        border: 'none',
    },

    '.accordionSummary .accordionSummary-details p': {
        fontFamily: getFontFamily('body.fontFamily.primary', theme),
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        textAlign: 'left',
        textUnderlinePosition: 'from-font',
        textDecorationSkipInk: 'none',
        color: '#333333',
    },
}));
